export default __webpack_public_path__ + "5eafd140172f5ba7f26cf5ce2fd7ce39.svg";